import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RestaurantComponent } from './Page/restaurant/restaurant.component';

const routes: Routes = [
  { path: '', component: RestaurantComponent },
  { path: ':id', component: RestaurantComponent },
  { path: 'rest/:id', component: RestaurantComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
